import { createContext, useContext } from "react";
import useAxios from "../Utils/useAxios";
import { 
  getItemSubmitSuccessMsg, 
  getItemDeleteSuccessMsg,
  getItemEditSuccessMsg
} from "../Constant/Message";
import { handleError, handleSuccess } from "../Utils/externalFunctions";

const CutiContext = createContext();

export const useCuti = () => useContext(CutiContext);

export const CutiProvider = ({ children }) => {
  const axiosInstance = useAxios();

  const api = {
    getCuti: () => 
      axiosInstance.get("sipeg/cuti/")
        .catch(err => handleError(err, "GET Cuti")),
    
    getCutiByYear: (year) => 
      axiosInstance.get(`sipeg/cuti-year/${year}`)
        .catch(err => handleError(err, "GET Cuti by Date")),
    
    getCutiByYearApprove: (year, approve) => 
      axiosInstance.get(`sipeg/cuti-year/${approve ? "approve" : "nonapprove"}/${year}`)
        .catch(err => handleError(err, "GET Cuti by Date")),
    
    getGroupStaf: () => 
      axiosInstance.get("sipeg/group-staf/")
        .catch(err => handleError(err, "GET Group Staf")),
    
    getStaf: () => 
      axiosInstance.get("sipeg/staf/")
        .catch(err => handleError(err, "GET Staf")),
    
    getTipeAbsensi: () => 
      axiosInstance.get("sipeg/tipe-absensi/")
        .catch(err => handleError(err, "GET Tipe Absensi")),
    
    createCuti: (formData) => 
      axiosInstance.post("sipeg/cuti/", formData)
        .then(res => handleSuccess(res, getItemSubmitSuccessMsg("Cuti")))
        .catch(err => handleError(err, "POST Cuti")),
    
    updateCuti: (id, formData) => 
      axiosInstance.put(`sipeg/cuti/${id}`, formData)
        .then(res => handleSuccess(res, getItemEditSuccessMsg("Cuti")))
        .catch(err => handleError(err, "PUT Cuti")),
    
    deleteCuti: (id) => 
      axiosInstance.delete(`sipeg/cuti/${id}`)
        .then(res => handleSuccess(res, getItemDeleteSuccessMsg("Cuti")))
        .catch(err => handleError(err, "DELETE Cuti"))
  };

  return (
    <CutiContext.Provider value={api}>
      {children}
    </CutiContext.Provider>
  );
};

export default CutiContext;